import { MantineColor, ThemeIcon } from "@mantine/core";
import cx from "clsx";
import { ReactNode } from "react";
import classes from "./ReceiveTicketUI.module.css";

/**
 * Thanh tiêu đề dùng chung cho các màn lập / sửa / xem phiếu.
 * Thay cho Badge gradient + Flex nút bấm trước đây.
 */
export const PageHeader = ({
  icon,
  title,
  subtitle,
  actions,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) => (
  <div className={classes.pageHeader}>
    <div className={classes.pageHeaderMain}>
      <div className={classes.pageHeaderIcon}>{icon}</div>
      <div className={classes.pageHeaderText}>
        <div className={classes.pageTitle}>{title}</div>
        {subtitle && <div className={classes.pageSubtitle}>{subtitle}</div>}
      </div>
    </div>
    {actions && <div className={classes.pageActions}>{actions}</div>}
  </div>
);

/**
 * Khối nội dung có tiêu đề, thay cho Fieldset.
 * Dùng `flush` khi bên trong đã là bảng tự có viền.
 */
export const SectionCard = ({
  icon,
  title,
  color = "blue",
  extra,
  flush,
  children,
}: {
  icon: ReactNode;
  title: string;
  color?: MantineColor;
  extra?: ReactNode;
  flush?: boolean;
  children: ReactNode;
}) => (
  <div className={classes.section}>
    <div className={classes.sectionHeader}>
      <ThemeIcon variant="light" color={color} size={24} radius="md">
        {icon}
      </ThemeIcon>
      <span className={classes.sectionTitle}>{title}</span>
      {extra && <div className={classes.sectionExtra}>{extra}</div>}
    </div>
    <div className={cx(classes.sectionBody, flush && classes.sectionBodyFlush)}>
      {children}
    </div>
  </div>
);
